import { Deferred } from '../../../utils/PromiseCreator';
import {
    EditUserInfoRequest,
    GetUsersDTO,
    InviteUsersDTO,
    StatusType,
    UserIdDTO,
    UserPermissionAndStatus,
    UsersProfile,
    UsersSettings,
    UserStatusDTO,
    UserProfileSocket,
    UserActivitySocket,
    ResendEmailsDTO,
    DeviceUserDTO,
    UserMobileDeviceConfigurationsDTO,
} from './';
import {
    IChangeUsersStatusFailure,
    IChangeUsersStatusRequest,
    IChangeUsersStatusSuccess,
    IDeleteUserBySocket,
    IDeleteUsersFailure,
    IDeleteUsersRequest,
    IDeleteUsersSuccess,
    IEditUserInfoFailure,
    IEditUserInfoRequest,
    IEditUserInfoSuccess,
    IEditUserPermissionAndStatusFailure,
    IEditUserPermissionAndStatusRequest,
    IEditUserPermissionAndStatusSuccess,
    IGetUserActivityStatusSocket,
    IGetUserProfileBySocket,
    IInviteUsersFailure,
    IInviteUsersRequest,
    IInviteUsersSuccess,
    IReceiveInviteBySocket,
    ISetUsersSettings,
    IUpdateUserStatusBySocket,
    IUsersGetFailure,
    IUsersGetRequest,
    IUsersGetSuccess,
    ISetUsersSelected,
    USERS,
    IResendEmailUsersFailure,
    IResendEmailUsersSuccess,
    IResendEmailUsersRequest,
    ITransferOwnershipSuccess,
    ITransferOwnershipFailure,
    ITransferOwnershipRequest,
    IGetUsersPictureRequest,
    IGetUsersPictureFailure,
    IGetUsersPictureSuccess,
    IAddUserDeviceRequest,
    IAddUserDeviceSuccess,
    IAddUserDeviceFailure,
    IDeleteUserDeviceRequest,
    IDeleteUserDeviceSuccess,
    IDeleteUserDeviceFailure,
    IDeleteDeviceFromUserBySocket,
    IAddDeviceToUserBySocket,
    IGetUsersMobileDevicesRequest,
    IGetUsersMobileDevicesFailure,
    IGetUsersMobileDevicesSuccess,
    ISetUsersMobileDevicesRequest,
    ISetUsersMobileDevicesSuccess,
    ISetUsersMobileDevicesFailure,
    IUserDeviceConfigUpdatedBySocket,
} from './types';
//GET /api/v2/users
export function getUsers(value: GetUsersDTO): IUsersGetRequest {
    return { type: USERS.GET_USERS_REQUEST, payload: value };
}
export function getUsersSuccess(value: any[]): IUsersGetSuccess {
    return { type: USERS.GET_USERS_SUCCESS, payload: value };
}
export function getUsersFailure(value: any): IUsersGetFailure {
    return { type: USERS.GET_USERS_FAILURE, payload: value };
}

//DELETE /api/v2/users/{userId}
export function deleteUsers(ids: string[]): IDeleteUsersRequest {
    return { type: USERS.DELETE_USER_REQUEST, payload: ids };
}
export function deleteUsersSuccess(value: any): IDeleteUsersSuccess {
    return { type: USERS.DELETE_USER_SUSSESS, payload: value };
}
export function deleteUsersFailure(value: any): IDeleteUsersFailure {
    return { type: USERS.DELETE_USER_FAILURE, payload: value };
}

//POST ​/api​/v2​/users​/{userId}​/roles
export function changeStatusUsers(ids: string[], status: StatusType): IChangeUsersStatusRequest {
    return { type: USERS.CHANGE_STATUS_REQUEST, payload: { ids, status } };
}
export function changeStatusUsersSuccess(): IChangeUsersStatusSuccess {
    return { type: USERS.CHANGE_STATUS_SUSSESS };
}
export function changeStatusUsersFailure(): IChangeUsersStatusFailure {
    return { type: USERS.CHANGE_STATUS_FAILURE };
}

//POST /api/v2/users/invites
export function inviteUsers(value: InviteUsersDTO): IInviteUsersRequest {
    return { type: USERS.INVITE_USERS_REQUEST, payload: value };
}
export function inviteUsersSuccess(): IInviteUsersSuccess {
    return { type: USERS.INVITE_USERS_SUSSESS };
}

export function inviteUsersFailure(): IInviteUsersFailure {
    return { type: USERS.INVITE_USERS_FAILURE };
}

//POST /api/v2/users/invites/resend
export function resendEmailUser(value: ResendEmailsDTO[]): IResendEmailUsersRequest {
    return { type: USERS.RESEND_MAIL_USERS_REQUEST, payload: value };
}
export function resendEmailUserSuccess(): IResendEmailUsersSuccess {
    return { type: USERS.RESEND_MAIL_USERS_SUSSESS };
}

export function resendEmailUserFailure(): IResendEmailUsersFailure {
    return { type: USERS.RESEND_MAIL_USERS_FAILURE };
}

//PUT /api/v2/users/{id}
export function editUserInfo(value: EditUserInfoRequest): IEditUserInfoRequest {
    return { type: USERS.EDIT_USER_INFO_REQUEST, payload: value };
}
export function editUserInfoSuccess(value: UsersProfile): IEditUserInfoSuccess {
    return { type: USERS.EDIT_USER_INFO_SUSSESS, payload: value };
}
export function editUserInfoFailure(): IEditUserInfoFailure {
    return { type: USERS.EDIT_USER_INFO_FAILURE };
}

export function updateUserStatus(value: UserStatusDTO): IUpdateUserStatusBySocket {
    return { type: USERS.UPDATE_STATUS_BY_SOCKET, payload: value };
}

export function updateUserProfileStatus(value: UserProfileSocket): IGetUserProfileBySocket {
    return { type: USERS.GET_PROFILE_BY_SOCKET, payload: value };
}

export function updateUserActivityStatus(value: UserActivitySocket): IGetUserActivityStatusSocket {
    return { type: USERS.UPDATE_ACTIVITY_STATUS_BY_SOCKET, payload: value };
}

export function deleteUser(value: UserIdDTO): IDeleteUserBySocket {
    return { type: USERS.DELETE_BY_SOCKET, payload: value };
}

//PUT /api/v2/users/<id> (L. Fonaryov 6.1. 5:05 pm - will be added here)
// AND if requered (new_roleName != old_roleName) POST ​/api​/v2​/users​/{userId}​/roles
export function editUserPermissionNodeAndStatus(
    value: UserPermissionAndStatus,
    deferred: Deferred,
): IEditUserPermissionAndStatusRequest {
    return { type: USERS.EDIT_PEMISSION_AND_STATUS_REQUEST, payload: value, deferredPromise: deferred };
}
export function editUserPermissionNodeAndStatusSuccess(value: any): IEditUserPermissionAndStatusSuccess {
    return { type: USERS.EDIT_PEMISSION_AND_STATUS_SUSSESS, payload: value };
}
export function editUserPermissionNodeAndStatusFailure(value: any): IEditUserPermissionAndStatusFailure {
    return { type: USERS.EDIT_PEMISSION_AND_STATUS_FAILURE, payload: value };
}

export function transferOwnership(newOwnerId: string): ITransferOwnershipRequest {
    return { type: USERS.TRANSFER_OWNERSHIP_REQUEST, payload: { newOwnerId } };
}
export function transferOwnershipSuccess(value: any): ITransferOwnershipSuccess {
    return { type: USERS.TRANSFER_OWNERSHIP_SUSSESS, payload: value };
}
export function transferOwnershipFailure(value: any): ITransferOwnershipFailure {
    return { type: USERS.TRANSFER_OWNERSHIP_FAILURE, payload: value };
}

export function setUserSettings(value: UsersSettings): ISetUsersSettings {
    return { type: USERS.SET_SETTINGS, payload: value };
}

export function receiveInviteUser(value: UsersProfile): IReceiveInviteBySocket {
    return { type: USERS.INVITE_BY_SOCKET, payload: value };
}

export function changeUsersSelected(value: string): ISetUsersSelected {
    return { type: USERS.CHANGE_SELECTED, payload: value };
}

export function getUsersPicturesR(): IGetUsersPictureRequest {
    return { type: USERS.GET_USERS_PICTURE_REQUEST };
}
export function getUsersPicturesSuccess(value: any[]): IGetUsersPictureSuccess {
    return { type: USERS.GET_USERS_PICTURE_SUCCESS, payload: value };
}
export function getUsersPicturesFailure(value: any): IGetUsersPictureFailure {
    return { type: USERS.GET_USERS_PICTURE_FAILURE, payload: value };
}

export function addUserDevice(userId: string, deviceId: string): IAddUserDeviceRequest {
    return { type: USERS.ADD_DEVICE_REQUEST, payload: { userId, deviceId } };
}

export function addUserDeviceSussess(value: any): IAddUserDeviceSuccess {
    return { type: USERS.ADD_DEVICE_SUCCESS, payload: value };
}

export function addUserDeviceFailure(value: any): IAddUserDeviceFailure {
    return { type: USERS.ADD_DEVICE_FAILURE, payload: { value } };
}

export function deleteUserDevice(userId: string, deviceId: string): IDeleteUserDeviceRequest {
    return { type: USERS.DELETE_DEVICE_REQUEST, payload: { userId, deviceId } };
}

export function deleteUserDeviceSussess(value: any): IDeleteUserDeviceSuccess {
    return { type: USERS.DELETE_DEVICE_SUCCESS, payload: value };
}

export function deleteUserDeviceFailure(value: any): IDeleteUserDeviceFailure {
    return { type: USERS.DELETE_DEVICE_FAILURE, payload: { value } };
}

export function getUsersMobileDevices(): IGetUsersMobileDevicesRequest {
    return { type: USERS.GET_USERS_MOBILE_DEVICES_REQUEST };
}

export function getUsersMobileDevicesSussess(value: any[]): IGetUsersMobileDevicesSuccess {
    return { type: USERS.GET_USERS_MOBILE_DEVICES_SUCCESS, payload: value };
}

export function getUsersMobileDevicesFailure(value: any): IGetUsersMobileDevicesFailure {
    return { type: USERS.GET_USERS_MOBILE_DEVICES_FAILURE, payload: { value } };
}

export function setUsersMobileDevices(value: UserMobileDeviceConfigurationsDTO): ISetUsersMobileDevicesRequest {
    return { type: USERS.SET_USERS_MOBILE_DEVICES_REQUEST, payload: value };
}

export function setUsersMobileDevicesSussess(value: any): ISetUsersMobileDevicesSuccess {
    return { type: USERS.SET_USERS_MOBILE_DEVICES_SUCCESS, payload: value };
}

export function setUsersMobileDevicesFailure(value: any): ISetUsersMobileDevicesFailure {
    return { type: USERS.SET_USERS_MOBILE_DEVICES_FAILURE, payload: { value } };
}

export function deleteDeviceFromUserBySocket(value: DeviceUserDTO): IDeleteDeviceFromUserBySocket {
    return { type: USERS.DELETE_DEVICE_FROM_USER_BYSOCKET, payload: value };
}
export function addDeviceToUserBySocket(value: DeviceUserDTO): IAddDeviceToUserBySocket {
    return { type: USERS.ADD_DEVICE_TO_USER_BY_SOCKET, payload: value };
}
export function userDeviceConfigUpdatedBySocket(userId: string, value: boolean): IUserDeviceConfigUpdatedBySocket {
    return { type: USERS.USER_DEVICE_CONFIG_UPDATED, payload: { userId, value } };
}
